import { isArray } from '@app/typeGuards'
import { arrayChunk } from '@app/utils/arrays'
import { objectGet, objectSet } from '@app/utils/object'

interface ProcessLargeDataChunksParams<ParamsType, ReturnType> {
  queryFn: (params: ParamsType) => Promise<ReturnType[]>
  dataPath: string[]
  chunkSize: number
}

export const processLargeDataChunks =
  <ParamsType, ReturnType>({ queryFn, dataPath, chunkSize }: ProcessLargeDataChunksParams<ParamsType, ReturnType>) =>
    async (params: ParamsType): Promise<ReturnType[]> => {
      const data: unknown[] = objectGet(params, dataPath)

      if (!isArray(data)) {
        throw new Error('Invalid parameters or data path!')
      }

      const chunks: unknown[][] = arrayChunk(data, chunkSize)

      const result: ReturnType[] = []

      for (const chunk of chunks) {
        const partParams = objectSet({}, dataPath, chunk)
        const response = await queryFn({ ...params, ...partParams })

        if (!response) continue

        if (!isArray(response)) {
          throw new Error('The result of the request should be an array!')
        }

        result.push(...response)
      }

      return result
    }
